import { render, staticRenderFns } from "./KPointEditForm.vue?vue&type=template&id=d0aab388&"
import script from "./KPointEditForm.vue?vue&type=script&lang=js&"
export * from "./KPointEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KPointEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports